import {
	getAction
} from '@/api/index';
export default {
	data() {
		return {
			keyWord: '',
			url: {
				searchAllContent: '/officialWebsite/c-api/search/allContent'
			},
			listData: []
		}
	},
	mounted() {
		if(this.$route && this.$route.query && this.$route.query.keyWord) {
			this.keyWord = this.$route.query.keyWord;
			this.loadData();
		}
		this.$bus.$on('search', (data) =>{
			this.keyWord = data.keyWord;
			this.loadData();
		})
	},
	methods: {
		convertTypeName(atype) {
			if(atype == 'product') {
				return '[产品服务]'
			}else if(atype == 'project') {
				return '[项目案例]'
			}else if(atype == 'tec') {
				return '[核心技术]'
			}
			return ''
		},
		onClickSearch() {
			if(!this.keyWord) return;
			if(this.$route.path == '/search') {
				this.loadData();
			}else {
				this.$router.push({path: 'search', query: {keyWord: this.keyWord}});
			}
		},
		async loadData() {
			const res = await getAction(this.url.searchAllContent, {keyWord: this.keyWord});
			if(res.success) {
				this.listData = res.result.map(it => {
					return {
						...it, 
						aname: this.convertTypeName(it.atype) + " "
							+ it.aname.replaceAll(this.keyWord, "<span style='color: rgb(49, 75, 137)'>"+this.keyWord+"</span>")
					}
				});
			}
		},
		onItemClick(item) {
			this.$router.push({
				path: '/detail?type='+item.atype+'&id=' + item.id
			});
		}
	}
}